import './App.css';
import Header from './Header';
import Stories from './Stories';
import Feed from './Feed';
import Footer from './Footer';
function App() {
  return (
    <div className="App">
      {/* Header */}
      <Header />

      {/* Stories */}
      <Stories />
      {/* Feed */}
      <Feed />



      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
